import { Component } from '@angular/core';
import { adminIngestionTypeEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Ingestion Types') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-adminingestiontype-form',
    templateUrl: './adminingestiontype.form.component.html'
})
export class adminIngestionTypeFormComponent extends BaseFormComponent {
    public record!: adminIngestionTypeEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'ingestionRuns', sectionName: 'Ingestion Runs', isExpanded: false }
        ]);
    }
}

